import { atom } from 'recoil';
import defaultLoading from 'ProjectManager/Project/List/recoil/loading/defaultLoading';

const projectsLoadingState = atom({
    key: 'projectManagement_projectsListLoading',
    default: defaultLoading,
});

export default projectsLoadingState;
